<template>
  <div class="workspace_wrap">
    <div class="carVR_top box">
      <i class="el-icon-warning yellow"></i>
      <span class="cardVR_top_t yellow">{{pageInfo?pageInfo:'暂无数据'}}</span>
    </div>
    <div class="card_labels box">
      <div class="card_label_title">商城标签</div>
      <div class>
        <el-tag
                :key="tag"
                v-for="(tag,index) in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(index)"
        >{{tag}}
        </el-tag>
        <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                maxlength="4"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
        ></el-input>
        <el-button class="button-new-tag" size="small" @click="showInput" v-if="dynamicTags.length<3">+ 新建标签
        </el-button>
      </div>
      <div class="card_consult">
        <div class="card_label_title">参考标签</div>
        <el-tag type="info" v-for="(item,index) in ReferenceLabel" :key="index" @click="addLeabel(index)" class="linetages">
          {{item}}
        </el-tag>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "cardTags",
    data() {
      return {
        dynamicTags: [],
        ReferenceLabel: ['款式新颖', '服务周到'],
        inputVisible: false,
        inputValue: "",
        pageInfo: ""
      };
    },
    created() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
      });
      this.InitFn(loading)
    },
    methods: {
      InitFn(loading) {
        this.axios
            .post(api.shopconf_label, {})
            .then(response => {
              if (response.data.code == 0) {
                this.pageInfo =  response.data.info
                this.dynamicTags = response.data.list
                loading.close();
              } else {
              }
            })
            .catch(response => {
            });
      },
      handleClose(index) {
        this.dynamicTags.splice(index,1)
        this.changeAddLeabel()
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          if (this.dynamicTags.indexOf(inputValue)!==-1) {
            this.$message({
              message: '标签已经存在',
              type: 'warning'
            });
            return
          }
          this.dynamicTags.push(inputValue);
          this.changeAddLeabel()
        }
        this.inputVisible = false;
        this.inputValue = "";
      },
      addLeabel(index) {
        if (this.dynamicTags.indexOf(this.ReferenceLabel[index])!==-1) {
          this.$message({
            message: '标签已经存在',
            type: 'warning'
          });
          return
        }
        this.dynamicTags.push(this.ReferenceLabel[index]);
        this.changeAddLeabel()
      },
      changeAddLeabel() {
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
         background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
        });
        this.axios
            .post(api.shopconf_label_edit, {labels: this.dynamicTags.join(',')})
            .then(response => {
              if (response.data.code == 0) {
                this.InitFn(loading)
              } else {
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>
